/* ============================================================
   RR SEARCH v7
   - Deduplicates results by handle
   - Shows ALL results (no slice cap)
   - VIEW ALL RESULTS button top-right when query active
   ============================================================ */
(function () {
  'use strict';

  var overlay, inputEl, resultsEl, labelEl, viewAllEl;
  var debounceTimer = null;
  var currentQuery  = '';
  var adapter       = null;

  function $(s, ctx) { return (ctx || document).querySelector(s); }

  function getHeaderHeight() {
    var sel = ['#SiteHeader', '.site-header', 'header.site-header', 'header'];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el) return Math.round(el.getBoundingClientRect().height);
    }
    return 70;
  }

  function positionOverlay() {
    if (overlay) overlay.style.top = getHeaderHeight() + 'px';
  }

  function money(paise) {
    if (!paise && paise !== 0) return '';
    return '\u20b9' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  /* Deduplicate by handle */
  function dedupe(products) {
    var seen = {};
    return (products || []).filter(function(p) {
      if (!p.handle || seen[p.handle]) return false;
      seen[p.handle] = true;
      return true;
    });
  }

  function skeleton(count) {
    if (labelEl) labelEl.textContent = '';
    if (viewAllEl) viewAllEl.classList.remove('is-visible');
    var h = '<div class="rr-search-grid">';
    for (var i = 0; i < (count || 4); i++) {
      h += '<div class="grid__item grid-product rr-search-grid-item">'
         + '<div class="rr-search-skeleton"></div>'
         + '</div>';
    }
    if (resultsEl) resultsEl.innerHTML = h + '</div>';
  }

  function renderProducts(products, label, query) {
    /* Deduplicate */
    products = dedupe(products);

    /* Update VIEW ALL link */
    if (viewAllEl) {
      if (query && products.length > 0) {
        viewAllEl.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        viewAllEl.classList.add('is-visible');
      } else {
        viewAllEl.classList.remove('is-visible');
      }
    }

    if (!products || !products.length) {
      if (labelEl) labelEl.textContent = '';
      if (resultsEl) resultsEl.innerHTML = '<p class="rr-search-empty">No products found</p>';
      return;
    }
    if (labelEl) labelEl.textContent = label || '';

    var html = '<div class="rr-search-grid">';

    /* Show ALL deduplicated products — no slice */
    products.forEach(function(p) {
      var img = p.image || '';
      if (img && img.indexOf('?') === -1) img += '?width=480';

      var onSale      = p.compareAt && p.compareAt > p.price;
      var discountPct = onSale ? Math.round((p.compareAt - p.price) * 100 / p.compareAt) : 0;

      var imgBlock = img
        ? '<div class="grid__image-ratio grid__image-ratio--portrait">'
            + '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;object-position:top center;">'
          + '</div>'
        : '<div class="grid__image-ratio grid__image-ratio--portrait" style="background:#f5f5f3;"></div>';

      var priceBlock = '<div class="grid-product__price">';
      if (onSale) {
        priceBlock += '<span class="grid-product__price--original">' + money(p.compareAt) + '</span>';
        priceBlock += '<span class="regularPrice">'  + money(p.price)      + '</span>';
        priceBlock += '<span class="grid-product__price--savings">' + discountPct + '%</span>';
      } else {
        priceBlock += '<span class="ccPrice">' + money(p.price) + '</span>';
      }
      priceBlock += '</div>';

      html +=
        '<div class="grid__item grid-product rr-search-grid-item">'
          + '<div class="grid-product__content">'
            + '<div class="grid__item-image-wrapper">'
              + '<div class="grid-product__image-mask">'
                + '<a href="' + (p.url || '/products/' + p.handle) + '" tabindex="-1">' + imgBlock + '</a>'
              + '</div>'
              + '<a href="' + (p.url || '/products/' + p.handle) + '" class="grid-product__link">'
                + '<div class="grid-product__meta">'
                  + '<div class="grid-product__title grid-product__title--body">' + (p.title || '') + '</div>'
                  + priceBlock
                + '</div>'
              + '</a>'
            + '</div>'
          + '</div>'
        + '</div>';
    });

    html += '</div>';
    if (resultsEl) resultsEl.innerHTML = html;
  }

  /* Shopify featured (no query) */
  function shopifyFeatured(callback) {
    fetch('/collections/all/products.json?limit=12&sort_by=best-selling')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        callback((d.products || []).map(function(p) {
          var v = p.variants && p.variants[0];
          return {
            handle:    p.handle,
            title:     p.title,
            url:       '/products/' + p.handle,
            price:     v ? Math.round(parseFloat(v.price) * 100) : 0,
            compareAt: v && v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
            image:     p.images && p.images[0] ? p.images[0].src : ''
          };
        }));
      })
      .catch(function() { callback([]); });
  }

  /* Shopify predictive search — fetch more results */
  function shopifySearch(query, callback) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product&resources[limit]=20'
      + '&resources[options][unavailable_products]=last')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var raw = (data.resources && data.resources.results && data.resources.results.products) || [];
        callback(raw.map(function(p) {
          return {
            handle:    p.handle,
            title:     p.title,
            url:       p.url,
            price:     p.price ? Math.round(parseFloat(p.price) * 100) : 0,
            compareAt: p.compare_at_price ? Math.round(parseFloat(p.compare_at_price) * 100) : 0,
            image:     p.featured_image && p.featured_image.url ? p.featured_image.url : ''
          };
        }));
      })
      .catch(function() { callback([]); });
  }

  function showRecommendations() {
    skeleton(4);
    if (viewAllEl) viewAllEl.classList.remove('is-visible');
    if (adapter && typeof adapter.recommend === 'function') {
      adapter.recommend(function(products) {
        renderProducts(products, 'YOU MIGHT BE INTERESTED IN', null);
      });
    } else {
      shopifyFeatured(function(products) {
        renderProducts(products, 'YOU MIGHT BE INTERESTED IN', null);
      });
    }
  }

  function runSearch(query) {
    query = (query || '').trim();
    if (query === currentQuery) return;
    currentQuery = query;
    if (!query) { showRecommendations(); return; }
    skeleton(4);
    if (adapter && typeof adapter.search === 'function') {
      adapter.search(query, function(products) {
        renderProducts(
          products,
          products.length ? 'RESULTS FOR \u201c' + query.toUpperCase() + '\u201d' : '',
          query
        );
      });
    } else {
      shopifySearch(query, function(products) {
        renderProducts(
          products,
          products.length ? 'RESULTS FOR \u201c' + query.toUpperCase() + '\u201d' : '',
          query
        );
      });
    }
  }

  function openSearch() {
    positionOverlay();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    currentQuery = '';
    if (inputEl) { inputEl.value = ''; inputEl.focus(); }
    if (viewAllEl) viewAllEl.classList.remove('is-visible');
    showRecommendations();
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'rr-search-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Search');
    overlay.innerHTML = [
      '<div class="rr-search-bar">',
        '<form class="rr-search-bar__form" role="search" action="/search" method="get" onsubmit="return false;">',
          '<input type="hidden" name="type" value="product">',
          '<span class="rr-search-bar__icon" aria-hidden="true">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">',
              '<circle cx="10.5" cy="10.5" r="6.5"/>',
              '<line x1="15.5" y1="15.5" x2="21" y2="21"/>',
            '</svg>',
          '</span>',
          '<input class="rr-search-input" name="q" type="search" placeholder="WHAT ARE YOU LOOKING FOR?" autocomplete="off" autocorrect="off" spellcheck="false">',
        '</form>',
        '<button class="rr-search-close" type="button" aria-label="Close search">',
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">',
            '<line x1="4" y1="4" x2="20" y2="20"/>',
            '<line x1="20" y1="4" x2="4" y2="20"/>',
          '</svg>',
        '</button>',
      '</div>',
      '<div class="rr-search-body">',
        '<div class="rr-search-label-row">',
          '<span class="rr-search-label" id="rrSLabel"></span>',
          '<a class="rr-search-view-all" id="rrSViewAll" href="/search">VIEW ALL RESULTS &rarr;</a>',
        '</div>',
        '<div id="rrSResults"></div>',
      '</div>'
    ].join('');

    document.body.appendChild(overlay);
    inputEl   = overlay.querySelector('.rr-search-input');
    resultsEl = overlay.querySelector('#rrSResults');
    labelEl   = overlay.querySelector('#rrSLabel');
    viewAllEl = overlay.querySelector('#rrSViewAll');

    overlay.querySelector('.rr-search-close').addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });
    inputEl.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var q = inputEl.value;
      debounceTimer = setTimeout(function() { runSearch(q); }, 300);
    });
    inputEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        var q = inputEl.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        e.preventDefault();
      }
    });
    window.addEventListener('resize', positionOverlay);
  }

  function initTriggers() {
    document.addEventListener('click', function(e) {
      var t = e.target;
      var trigger =
        t.closest('.js-search-header') ||
        t.closest('[data-action="open-search"]') ||
        (t.closest('a') && t.closest('a').getAttribute('href') === '/search' && !t.closest('.rr-search-overlay'));
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openSearch();
      }
    }, true);
  }

  function init() {
    buildOverlay();
    initTriggers();
    window.rrSearch = {
      open:  openSearch,
      close: closeSearch,
      setAdapter: function(a) {
        adapter = a;
        if (overlay && overlay.classList.contains('is-open') && !currentQuery) {
          showRecommendations();
        }
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
